import { PreferenceThemeColorsEnum, PreferenceThemeSlugsEnum } from "@_types/preferences";
import { UpdatePreferenceInput } from "@_types/preferences/Preference.use-cases";
import { ImageType } from "react-images-uploading";

export interface PreferencesActions {
  setPreferences: (data: UpdatePreferenceInput) => void;
  fetchPreferences: (courseUuid: string) => Promise<void>;
  updatePreferences: (courseUuid: string, preferencesStates: UpdatePreferenceInput) => Promise<void>;
  uploadLogo: (courseUuid: string, file: File) => Promise<void>;
  removeLogo: (courseUuid: string) => Promise<void>;
  openUploadModal: () => void;
  closeUploadModal: () => void;
  setImageFiles: (logoFiles: ImageType[]) => void;
}

export interface PreferencesStoreProps extends UpdatePreferenceInput {
  isLoading?: boolean;
  isUpdating?: boolean;
  temporaryLogo?: string | null;
  isUploadModalOpen?: boolean;
  logoFiles?: ImageType[] | null;
}
export const ThemeStyles = {
  [PreferenceThemeSlugsEnum.CLEAN]: {
    primary: PreferenceThemeColorsEnum.CLEAN,
    hover: "#4dc6ff",
    pressed: "#19b6ff",
    contrast: "#E3E5E8",
  },
  [PreferenceThemeSlugsEnum.HEART]: {
    primary: PreferenceThemeColorsEnum.HEART,
    hover: "#E25A7F",
    pressed: "#DA2F5D",
    contrast: "#E3E5E8",
  },
  [PreferenceThemeSlugsEnum.MAGIC]: {
    primary: PreferenceThemeColorsEnum.MAGIC,
    hover: "#B873DE",
    pressed: "#A049DF",
    contrast: "#171717",
  },
  [PreferenceThemeSlugsEnum.SUN]: {
    primary: PreferenceThemeColorsEnum.SUN,
    hover: "#FFE74C",
    pressed: "#E5C700",
    contrast: "#E3E5E8",
  },
  [PreferenceThemeSlugsEnum.OCEAN]: {
    primary: PreferenceThemeColorsEnum.OCEAN,
    hover: "#4DC6FF",
    pressed: "#19B6FF",
    contrast: "#E3E5E8",
  },
  [PreferenceThemeSlugsEnum.MARS]: {
    primary: PreferenceThemeColorsEnum.MARS,
    hover: "#F28F0D",
    pressed: "#AA6409",
    contrast: "#E3E5E8",
  },
  [PreferenceThemeSlugsEnum.MINT]: {
    primary: PreferenceThemeColorsEnum.MINT,
    hover: "#72D5AB",
    pressed: "#34AD7A",
    contrast: "#E3E5E8",
  },
};
